import Modal from "../utils/classes/Modal";
import { disableVideo, enableVideo } from "../utils/video";

export default function (el) {
    const modal = new Modal(el);
    const hasVideo = el.dataset && el.dataset.hasVideo;

    modal.run();
    
    if(hasVideo) {
        modal.on("open", enableVideo.bind(null, modal.modal));
        modal.on("close", disableVideo.bind(null, modal.modal));
    }
}